import * as React from 'react';

type RadioButtonProps = React.InputHTMLAttributes<HTMLInputElement> & {
  checked: boolean;
  children?: React.ReactNode;
  containerClassName?: string;
  onContainerClick?: () => void;
};

const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  children,
  containerClassName = '',
  onContainerClick,
  ...props
}) => (
  <div
    className={`flex items-center p-3 rounded-lg border cursor-pointer transition ${checked
      ? 'border-gray-400 bg-gray-50'
      : 'border-gray-200 bg-white hover:bg-gray-50'} ${containerClassName}`}
    onClick={onContainerClick}
  >
    <label className="inline-flex items-center cursor-pointer relative m-0">
      <input
        type="radio"
        checked={checked}
        {...props}
        className="sr-only"
        onClick={e => e.stopPropagation()}
      />
      <span
        className={`
          w-5 h-5 flex items-center justify-center rounded-full border-2
          ${checked ? 'border-primary bg-primary' : 'border-gray-300 bg-white'}
          transition-colors
        `}
      >
        {checked && (
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 16 16">
            <polyline points="4,8 7,11 12,5" />
          </svg>
        )}
      </span>
      {children && <span className="ml-3">{children}</span>}
    </label>
  </div>
);

export default RadioButton;
